/**
 * @flow
 */
'use strict';

export const colorVisionTestCodes = [
{"code":"D-15"},
{"code":"Ishihara"},
{"code":"Ishiara (path)"},
]

export const colorVisionDiagnoseCodes = [
{"code":"Normal"},
{"code":"Deuteranomaly"},
{"code":"Deuteranopia"},
{"code":"Protanomaly"},
{"code":"Protanopia"},
{"code":"Tritanomaly"},
{"code":"Tritanopia"},
{"code":"Monochromacy"}
]
